import { css } from 'styled-components';

const withColor = css`
  background-color: ${(p) => p.color}  !important;
  color: #fff !important;
`;

export default withColor;
